import { getApi, postApi, putApi, deleteApi } from 'apis';

const createLeaveRequest = async (data: any) => {
	return await postApi('/leaveRequest', data, true);
};

const updateLeaveRequest = async (id: string, data: any) => {
	return await putApi(`/leaveRequest/${id}`, data, true);
};

const deleteLeaveRequest = async (id: string) => {
	return await deleteApi(`/leaveRequest/delete/${id}`);
};

const getLeaveRequests = async (params: any) => {
	return await getApi('/leaveRequest', params);
};

const getLeaveRequestById = async (id: string) => {
	return await getApi(`/leaveRequest/${id}`);
};


export const leaveRequestApi = {
	createLeaveRequest,
	updateLeaveRequest,
	deleteLeaveRequest,
	getLeaveRequests,
	getLeaveRequestById,
};
